module.exports = __webpack_public_path__ + "static/media/28.0b40af60.png";